import React, { useState, useEffect } from 'react';
import './aboutus.css';

// Import images from public folder (assuming images are in public folder)
// For professional1 to professional40, they will be loaded from /professional1.png etc.

function AboutUs() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Generate 40 professionals
const professionals = [

  // { id: 1, name: "Dr. Jerish Neeraj", role: "Physician, Biomedical Engineer & Medico-Legal Advisor", image: "/0.jpeg" },
  // { id: 2, name: "Dr. Radheshyam Gupta", role: "Physician, General Surgeon & Robotic Uro-Oncologist", image: "/37.jpeg" },
  // { id: 3, name: "Dr.Sajad Ahamed", role: "Specialist Physician- Medicine", image: "/35.jpeg" },
  // { id: 4, name: "Dr. Kogilshankar", role: "Physician, Acting Consultant Forensic Medicine & JMO", image: "/36.jpeg" },
  // { id: 5, name: "Mr. Deniswaran", role: "Senior Attorney-at-Law", image: "/21.jpeg" },
  // { id: 6, name: "Mr. M. M. M. P. Manathunga", role: "Senior Attorney-at-Law", image: "/22.jpeg" },
  // { id: 7, name: "Mrs. Sharmila Patmanathan", role: "Senior Attorney-at- Law & Visiting Lecturer", image: "/20.jpeg" },
  // { id: 8, name: "Dr. Vipin Kumar", role: "Specialist Physician - Cardiology", image: "/33.jpeg" },
  // { id: 9, name: "Dr. Sanjeeban", role: "Physician & Consultant - Medicine", image: "/27.jpeg" },
  // { id: 10, name: "Dr.Sahil Abbas", role: "Specialist Physician - Endocrinology", image: "/34.jpeg" },
  // { id: 11, name: "Dr. Vasanthan Croos", role: "Family Physician & Registrar - Family Medicine", image: "/30.jpeg" },
  // { id: 12, name: "Dr. Aananthasri", role: "Physician", image: "/32.jpeg" },
  // { id: 13, name: "Dr. Pio Wilfred", role: "Physician", image: "/39.jpeg" },
  // { id: 14, name: "Dr. Hareasvaran", role: "Physician", image: "/29.jpeg" },
  // { id: 15, name: "Dr.Diron", role: "Physician", image: "/28.jpeg" },
  // { id: 16, name: "Dr. Francis Ebiron", role: "Physician", image: "/26.jpeg" },
  // { id: 17, name: "Dr. Godwin Peries", role: "MBBS(Bangladesh)", image: "/24.jpeg" },
  // { id: 18, name: "Mr. Chandrajith", role: "Clinical & Health Psychologist", image: "/8.jpeg" },
  // { id: 19, name: "Mr. Vakeeshan", role: "Physiotherapist", image: "/13.jpeg" },
  // { id: 20, name: "Mrs. Ramya Janarath", role: "Senior Dietitian", image: "/11.jpeg" },
  // { id: 21, name: "Mrs. M. Fathima Nasriya", role: "Registered Dietitian & Nutritionist", image: "/10.jpeg" },
  // { id: 22, name: "Ms. Nivedha Abiramy", role: "Chemist & Food Technologist", image: "/9.jpeg" },

  // { id: 24, name: "Mr. M. Azaar", role: "Business Advisor", image: "/1.jpeg" },
  // { id: 25, name: "Dr. K. Kabilan", role: "Ayurvedic Physician", image: "/7.jpeg" },
  // { id: 26, name: "Mr. Gowsigan", role: "Biomedical Scientist", image: "/3.jpeg" },
  // { id: 27, name: "Mr. K. Lavan", role: "MLT", image: "/2.jpeg" },
  // { id: 28, name: "Mr. Dhananjaya", role: "Biomedical Engineer", image: "/14.jpeg" },
  // { id: 29, name: "Ms. Nuhansa Herath", role: "Biomedical Engineer", image: "/16.jpeg" },
  // { id: 30, name: "Ms. Jinushiya Manaoharan", role: "Biomedical Engineer", image: "/17.jpeg" },
  // { id: 31, name: "Mr. Tharindu Madushanka", role: "Biomedical Engineer", image: "/15.jpeg" },
  // { id: 32, name: "Mrs. Kirusha", role: "Radiographer", image: "/5.jpeg" },
  // { id: 33, name: "Mr. Tony Thilpkumar", role: "Pharmacist", image: "/4.jpeg" },

  {
    id: 1,
    name: "Dr. Jerish Neeraj",
    role: "Physician, Biomedical Engineer & Medico-Legal Advisor",

qualification: [
  "MBBS (China)",
  "BEng (Hons) Biomedical Engineering (UK)",
  "LLB (Hons) (London, UK)",
  "LLM (International Business Law, UK)",
  "MBA (Health Sector Management)",
  "MPhil (Clinical Nutrition) (PGIA, SL)",
  "DBA (Health Services Management)",
  "PhD (Medical Law & Ethics with Health Psychology)"
],

    experience: "15+ Years Experience",
    regNo: "",
    image: "/0.jpeg"
  },
  {
    id: 2,
    name: "Dr. Radheshyam Gupta",
    role: "Physician, General Surgeon & Robotic Uro-Oncologist",
    qualification: "General Surgeon & Robotic Uro-Oncologist, MBBS (China), MS (General Surgery) (China), PhD (Urology & Robotic Oncology) (China), Fellowship in Endourology & Renal Transplant (USA)",
    experience: "15+ Years Experience",
    regNo: "",
    image: "/37.jpeg"
  },
  {
    id: 3,
    name: "Dr. Sajad Ahamed",
    role: "Specialist Physician - Medicine",
    qualification: "MBBS (China), DNB in General Medicine (India)",
    experience: "14+ Years Experience",
    regNo: "",
    image: "/35.jpeg"
  },
  {
    id: 4,
    name: "Dr. Kogilshankar",
    role: "Physician, Acting Consultant Forensic Medicine & JMO",
    qualification: "Acting Consultant Forensic Medicine & JMO, MBBS (SL), DLM (Diploma in Legal Medicine) (SL), MD (Forensic Medicine) (SL)",
    experience: "15+ Years Experience",
    regNo: "",
    image: "/36.jpeg"
  },
  {
    id: 5,
    name: "Mr. Deniswaran",
    role: "Senior Attorney-at-Law",
    qualification: "Senior Lawyer – District Court of Mannar, LLB (Colombo), Attorney-at-Law (Colombo)",
    experience: "20+ Years Experience",
    regNo: "",
    image: "/21.jpeg"
  },
  {
    id: 6,
    name: "Mr. M. M. M. P. Manathunga",
    role: "Senior Attorney-at-Law",
    qualification: "Senior Lawyer – Supreme Court of Colombo, LLB (Colombo), Attorney-at-Law (Colombo)",
    experience: "20+ Years Experience",
    regNo: "Bar Association Registered",
    image: "/22.jpeg"
  },
  {
    id: 7,
    name: "Mrs. Sharmila Patmanathan",
    role: "Senior Attorney-at-Law & Visiting Lecturer",
    qualification: "Lawyer at Magistrate, District & High Court of Nuwara Eliya, LLB (Hons) (Colombo), Attorney-at-Law (Colombo), LLM (Public & International Law) (Colombo)",
    experience: "10+ Years Experience",
    regNo: "Bar Association Registered",
    image: "/20.jpeg"
  },
  {
    id: 8,
    name: "Dr. Vipin Kumar",
    role: "Specialist Physician - Cardiology",
    qualification: "MBBS (China), MD (Cardiology) (China), PhD (Cardiology) (China) (Reading)",
    experience: "08+ Years Experience",
    regNo: "",
    image: "/33.jpeg"
  },

  {
    id: 9,
    name: "Dr. Sanjeeban",
    role: "Physician & Consultant - Medicine",
    qualification: "MBBS, MD Medicine",
    experience: "13+ Years Experience",
    regNo: "",
    image: "/27.jpeg"
  },
  {
    id: 10,
    name: "Dr. Sahil Abbas",
    role: "Specialist Physician - Endocrinology",
    qualification: "MBBS (China), MD (Internal Medicine) (China), PhD (Endocrinology) (China)",
    experience: "14+ Years Experience",
    regNo: "",
    image: "/34.jpeg"
  },
  {
    id: 11,
    name: "Dr. Vasanthan Croos",
    role: "Family Physician & Registrar - Family Medicine",
    qualification: "Registrar - Family Medicine & Physician, MBBS (Bangladesh), DFM (Diploma in Family Medicine) (SL), MD (Family Medicine) (SL) (Reading)",
    experience: "10+ Years Experience",
    regNo: "",
    image: "/30.jpeg"
  },


  {
    id: 12,
    name: "Dr. Aananthasri",
    role: "Physician",
    qualification: "MBBS (China)",
    experience: "08+ Years Experience",
    regNo: "SLMC Reg.No: 38795",
    image: "/32.jpeg"
  },


  {
    id: 38,
    name: "Dr. Sameera Wijesundera",
    role: "General Physician",
    qualification: "MBBS (China)",
    experience: "15+ Years Experience",
    regNo: "",
    image: "/31.jpeg"
  },


  {
    id: 13,
    name: "Dr. Pio Wilfred",
    role: "Physician",
    qualification: "Physician MD (Ukraine)",
    experience: "10+ Years Experience",
    regNo: "SLMC Reg.No:44175",
    image: "/39.jpeg"
  },
  {
    id: 14,
    name: "Dr. Hareasvaran",
    role: "Physician",
    qualification: "MD (Belarus)",
    experience: "10+ Years Experience",
    regNo: "SLMC Reg.No:90047",
    image: "/29.jpeg"
  },
  {
    id: 15,
    name: "Dr. Diron",
    role: "Physician",
    qualification: "MBBS (Bangladesh)",
    experience: "08+ Years Experience",
    regNo: "SLMC Reg. No: 40427",
    image: "/28.jpeg"
  },
  {
    id: 16,
    name: "Dr. Francis Ebiron",
    role: "Physician",
    qualification: "MBBS (SL)",
    experience: "10+ Years Experience",
    regNo: "SLMC Reg.No: ",
    image: "/26.jpeg"
  },

  {
    id: 34,
    name: "Dr. Santhosh Anthony ",
    role: "General Physician",
    qualification: "General Physician & Director of Long Live Care, MD (Ukraine)",
    experience: "10+ Years Experience",
    regNo: "",
    image: "/38.jpeg"
  },


  {
    id: 35,
    name: "Dr. Prajana",
    role: "General Physician",
    qualification: "MD (Russia)",
    experience: "08+ Years Experience",
    regNo: "",
    image: "/25.jpeg"
  },



  {
    id: 17,
    name: "Dr.Godwin Peries",
    role: "General Physician",
    qualification: "MBBS (Bangladesh)",
    experience: "01+ Years Experience",
    regNo: "",
    image: "/24.jpeg"
  },

 {
    id: 36,
    name: "Dr. Natalya Dissanayake",
    role: "General Physician",
    qualification: "MBBS (KDU SL)",
    experience: "01+ Years Experience",
    regNo: "",
    image: "/23.jpeg"
  },

  {
    id: 18,
    name: "Mr. Chandrajith",
    role: "Clinical & Health Psychologist",
    qualification: "BSc (Psychology), MSc (Clinical & Health Psychology)",
    experience: "10+ Years Experience",
    regNo: "",
    image: "/8.jpeg"
  },

  {
    id: 19,
    name: "Mr. Vakeeshan",
    role: "Physiotherapist",
    qualification: "BSc (Hons) (Special in Physiotherapy) (SL)",
    experience: "15+ Years Experience",
    regNo: "SLMC Reg.No: 0398",
    image: "/13.jpeg"
  },
  {
    id: 20,
    name: "Mrs. Ramya Janarath",
    role: "Senior Dietitian",
    qualification: "BSc (Nutrition & Dietetics) (India), PGCert (Human Nutrition) (UK), MSc (Food Science & Nutrition) (PGIA SL)",
    experience: "20+ Years Experience",
    regNo: "SLMC Reg.No:07 | Professional Memberships: NSSL, DIASL, IAPEN",
    image: "/11.jpeg"
  },
  {
    id: 21,
    name: "Mrs. M. Fathima Nasriya",
    role: "Registered Dietitian & Nutritionist",
    qualification: "BSc (Hons) (Food Science & Nutrition) (SL), MSc (Food Science & Nutrition) (PGIA SL)",
    experience: "05+ Years Experience",
    regNo: "SLMC Reg. No:89 (Dietitian) | SLMC Reg. No:249 (Nutritionist)",
    image: "/10.jpeg"
  },
  {
    id: 22,
    name: "Ms. Nivedha Abiramy",
    role: "Chemist & Food Technologist",
    qualification: "BSc(Food Science & Technology)(SL), MSc(Food Science & Technology)(SL)(Reading), MBA(General)(SL)",
    experience: "09+ Years Experience",
    regNo: "Professional Chemist",
    image: "/9.jpeg"
  },

  {
    id: 24,
    name: "Dr. K. Kabilan",
    role: "Ayurvedic Physician",
    qualification: "Ayurvedic Physician, BSMS (SL)",
    experience: "04+ Years Experience",
    regNo: "BSMS Reg.No:16197",
    image: "/7.jpeg"
  },
  {
    id: 25,
    name: "Mr. Gowsigan",
    role: "Biomedical Scientist",
    qualification: "BSc (Microbiology & Biotechnology) (UK), Diploma in Cosmetic Technology (SL)",
    experience: "03+ Years Experience",
    regNo: "Biomedical Scientist",
    image: "/3.jpeg"
  },
  {
    id: 26,
    name: "Mr. K. Lavan",
    role: "MLT",
    qualification: "Medical Laboratory Technologist, MLT (SL)",
    experience: "20+ Years Experience",
    regNo: "",
    image: "/2.jpeg"
  },
  {
    id: 27,
    name: "Mr. Dhananjaya",
    role: "Biomedical Engineer",
    qualification: "BSc Biomedical Engineering (UK)",
    experience: "1+ Years Experience",
    regNo: "",
    image: "/14.jpeg"
  },
  {
    id: 28,
    name: "Ms. Nuhansa Herath",
    role: "Biomedical Engineer",
    qualification: "BEng (Hons) Biomedical Engineering (UK)",
    experience: "1+ Years Experience",
    regNo: "",
    image: "/16.jpeg"
  },
  {
    id: 29,
    name: "Ms. Jinushiya Manaoharan",
    role: "Biomedical Engineer",
    qualification: "BSc Biomedical Engineering (UK)",
    experience: "1+ Years Experience",
    regNo: "",
    image: "/17.jpeg"
  },
  {
    id: 30,
    name: "Mr. Tharindu Madushanka",
    role: "Biomedical Engineer",
    qualification: "BSc Biomedical Engineering (UK)",
    experience: "1+ Years Experience",
    regNo: "",
    image: "/15.jpeg"
  },
  {
    id: 31,
    name: "Mrs. Kirusha",
    role: "Radiographer",
    qualification: "BSc (Hons) Radiography (SL)",
    experience: "10+ Years Experience",
    regNo: "",
    image: "/5.jpeg"
  },
  {
    id: 32,
    name: "Mr. Tony Thilakumar",
    role: "Pharmacist",
    qualification: "BPharm (Hons)(SL), MPH (Malaysia)(Reading)",
    experience: "10+ Years Experience",
    regNo: "Registered Pharmacist",
    image: "/4.jpeg"
  },



  {
    id: 33,
    name: "Ms. Narmatha Shanmuganathan",
    role: "Attorney-at-Law (SL)",
    qualification: "LLB (Hons) (SL)",
    experience: "5+ Years Experience",
    regNo: "Pharmacy Council Registered",
    image: "/19.jpeg"
  },







   
 

  
  {
    id: 37,
    name: "Mr. Banushan Thamilchelvan",
    role: "Physiotherapist",
    qualification: "BSc (Hons) Physiotherapy",
    experience: "04+ Years Experience",
    regNo: "SLMC Reg. No: 15145",
    image: "/12.jpeg"
  },


  
  {
    id: 38,
    name: "Dr. Sameera Wijesundera",
    role: "General Physician",
    qualification: "MBBS (China)",
    experience: "15+ Years Experience",
    regNo: "",
    image: "/31.jpeg"
  },

   
  {
    id: 39,
    name: "Ms. Elilnangai Tamilchelvan",
    role: "Speech & Language Pathologist",
    qualification: "BSc (Hons) in Speach Therapy",
    experience: "08+ Years Experience",
    regNo: "",
    image: "/6.jpeg"
  },

 

  {
    id: 40,
    name: " Mr. Shantha kumar ",
    role: "Legal Advisor",
    qualification: "LLB (Hons) (UK)",
    experience: "10+ Years Experience",
    regNo: "",
    image: "/18.jpeg"
  },
 

    {
    id: 23,
    name: "Mr. M. Azaar",
    role: "Business Advisor",
    qualification: "BBA (India)",
    experience: "15+ Years Experience",
    regNo: "",
    image: "/1.jpeg"
  },

];







 
  





  function getRoleForIndex(index) {
    const roles = [
      "Medical Advisor", "Clinical Psychologist", "Biomedical Engineer", "Legal Consultant",
      "Nutrition Specialist", "Sports Scientist", "Data Scientist", "Medico-Legal Expert",
      "Behavioral Therapist", "Rehabilitation Specialist", "AI Health Informatician", "Clinical Researcher",
      "Sports Psychologist", "Dietitian", "Forensic Analyst", "Healthcare Manager",
      "Child Psychologist", "Biomechanist", "Pharmacologist", "Radiology Expert",
      "Endocrinologist", "Cardiologist", "Neurologist", "Orthopedic Specialist",
      "Physiotherapist", "Occupational Therapist", "Public Health Expert", "Epidemiologist",
      "Health Economist", "Policy Advisor", "Medical Writer", "Regulatory Specialist",
      "Quality Assurance Lead", "Training Coordinator", "Research Associate", "Clinical Coordinator",
      "Wellness Coach", "Performance Analyst", "Risk Manager", "Ethics Consultant"
    ];
    return roles[index % roles.length];
  }

  const coreValues = [
    { title: "Scientific Excellence", desc: "Evidence-based approaches in every advisory service" },
    { title: "Ethical Integrity", desc: "Strict professional and legal compliance in all operations" },
    { title: "Multidisciplinary Integration", desc: "Medicine, law, psychology, engineering unified" },
    { title: "Client-Centered Care", desc: "Personalized, compassionate, and strategic guidance" },
    { title: "Innovation Leadership", desc: "AI-driven insights and future-ready solutions" }
  ];

  return (
    <div className="djm-about-container">
      {/* Hero Banner */}
      <section className="djm-about-hero">
        <div className="djm-about-hero-overlay"></div>
        <div className="djm-about-hero-content">
      
          <h1 className="djm-about-hero-title">About Us</h1>
<p className="djm-about-hero-subtitle">
  Integrated Medical Intelligence &nbsp;
  <span className="djm-mobile-break"></span>
  & 
  <span className="djm-mobile-break"></span>
 &nbsp; Medico-Legal Advisory &nbsp;
  <span className="djm-mobile-break"></span>
  &
  <span className="djm-mobile-break"></span>
 &nbsp; Human Behavior Advisory &nbsp;
  <span className="djm-mobile-break"></span>
  &
  <span className="djm-mobile-break"></span>
 &nbsp; Human Performance Advisory
</p>
          <div className="djm-about-hero-line"></div>
          <p className="djm-about-hero-text">
            We provide an integrated approach to modern healthcare through Medical Advisory & Applied Psychology, 
            Medico-Legal & Medical Ethics services, Digital Health Accessories with Wellness & Sports Biomechanics Solutions, 
            Biomedical Engineering & Sports Biomechanics Advisory, and AI Health Informatics with CSR Health Services. 
            We combine science, technology, and ethics to deliver innovative, patient-focused healthcare solutions.
          </p>
        </div>
      </section>

      {/* Founder & CEO Section */}
      <section className="djm-founder-section">
        <div className="djm-container">
          <div className="djm-founder-card">
            <div className="djm-founder-image">
              <img src="/dr-jery.jpeg" alt="Dr. Eng. Jerish Neeraj" />
              <div className="djm-founder-badge">FOUNDER, CEO & DIRECTOR</div>
            </div>
            <div className="djm-founder-content">
              <h2 className="djm-founder-name">Dr. Eng. Jerish Neeraj</h2>
              <p className="djm-founder-titles">
                Physician, Biomedical Engineer, Medical Data Scientist, Chartered Manager, Medical Advisor, 
                Legal Advisor, Medico-Legal Advisor, Clinical Nutrition Consultant, AI Health Informatics & 
                Management Consultant, Applied Health Psychologist, Biomechanist, Visiting Lecturer
              </p>
              
              <div className="djm-founder-qualifications">
                <h3>Academic Qualifications</h3>
                <div className="djm-qual-grid">
                  <span className="djm-qual-item">MBBS (Clinical Medicine) - China</span>
                  <span className="djm-qual-item">BEng (Hons) (Biomedical Engineering) - London, UK</span>
                  <span className="djm-qual-item">LLB (Hons) - London, UK</span>
                  <span className="djm-qual-item">LLM (International Business Law) - Cardiff, UK</span>
                  <span className="djm-qual-item">MBA (Health Sector Management) - Cardiff, UK</span>
                  <span className="djm-qual-item">MSc (Data Science with AI-Based Health Informatics) - London, UK</span>
                  <span className="djm-qual-item">MSc (Applied Psychology & Behavior Change) - Cardiff, UK</span>
                  <span className="djm-qual-item">MPhil (Clinical Nutrition) - PGIA, SL</span>
                  <span className="djm-qual-item">DBA (Health Services Management) - Malaysia</span>
                  <span className="djm-qual-item">PhD (Medical Law & Ethics with Applied Psychology) - Cambodia</span>
                  <span className="djm-qual-item">CMgr-MCPM (SL)</span>
                  <span className="djm-qual-item">Attorney-at-Law (Reading)</span>
                </div>
              </div>

              <div className="djm-founder-vision">
                <h3>Vision</h3>
                <p>To create a global system where medical decisions are scientifically interpreted, legal-medical conflicts are professionally structured, behavioral health is scientifically guided, sports performance is biomechanically optimized, and clinical nutrition is evidence-based.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Who We Are Section */}
      <section className="djm-whoweare-section">
        <div className="djm-container">
          <div className="djm-whoweare-grid">
            <div className="djm-whoweare-content">
              <div className="djm-section-tag">Who We Are</div>
              <h2 className="djm-section-title">Integrated Medical-Legal-Scientific-Behavioral Intelligence</h2>
              <div className="djm-title-line"></div>
              <p className="djm-whoweare-text">
                Dr. Jery Medico (Pvt) Ltd is a premium global advisory institution specializing in medico-legal consulting, 
                psychological behavior change systems, sports biomechanics, clinical nutrition optimization, clinical data science, 
                health informatics, and strategic healthcare management advisory services.
              </p>
              <p className="djm-whoweare-text">
                Our professional model represents a new generation of healthcare leadership—integrating clinical medicine, 
                biomedical engineering, law, healthcare management, psychology, nutrition, data science, and strategic leadership 
                into one unified advisory ecosystem.
              </p>
              <div className="djm-unique-position">
                <p>“Integrated Medical–Legal–Scientific–Behavioral Intelligence for Modern Healthcare Systems.”</p>
              </div>
            </div>
            <div className="djm-whoweare-stats">
              <div className="djm-stat-card">
                <span className="djm-stat-number">15+</span>
                <span className="djm-stat-label">Years Experience</span>
              </div>
              <div className="djm-stat-card">
                <span className="djm-stat-number">12+</span>
                <span className="djm-stat-label">Degrees & Certifications</span>
              </div>
              <div className="djm-stat-card">
                <span className="djm-stat-number">40+</span>
                <span className="djm-stat-label">Expert Professionals</span>
              </div>
              <div className="djm-stat-card">
                <span className="djm-stat-number">5+</span>
                <span className="djm-stat-label">Core Divisions</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission, Vision, Values Section */}
      <section className="djm-mvv-section">
        <div className="djm-container">
          <div className="djm-mvv-grid">
            <div className="djm-mvv-card">
              <div className="djm-mvv-icon"></div>
              <h3>Our Mission</h3>
              <p>To deliver structured medical intelligence, behavioral insight, and strategic health guidance that empowers individuals and institutions to make informed, confident decisions about health, performance, and well-being.</p>
            </div>
            <div className="djm-mvv-card">
              <div className="djm-mvv-icon"></div>
              <h3>Our Vision</h3>
              <p>To become a globally recognized medical and behavioral intelligence system integrating medicine, engineering, psychology, law, and data-driven advisory for transformative healthcare solutions.</p>
            </div>
            <div className="djm-mvv-card">
              <div className="djm-mvv-icon"></div>
              <h3>Our Values</h3>
              <ul>
                <li>Scientific Excellence</li>
                <li>Ethical Integrity</li>
                <li>Multidisciplinary Integration</li>
                <li>Client-Centered Care</li>
                <li>Innovation Leadership</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Core Values Expanded */}
      <section className="djm-values-section">
        <div className="djm-container">
          <div className="djm-section-header">
            <span className="djm-section-tag">Our Core Values</span>
            <h2 className="djm-section-title">What Drives Us</h2>
            <div className="djm-title-line"></div>
          </div>
          <div className="djm-values-grid">
            {coreValues.map((value, idx) => (
              <div key={idx} className="djm-value-card">
                <div className="djm-value-icon"></div>
                <h3>{value.title}</h3>
                <p>{value.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Our Divisions Section */}
      <section className="djm-divisions-section">
        <div className="djm-container">
          <div className="djm-section-header">
            <span className="djm-section-tag">Our Expertise</span>
            <h2 className="djm-section-title">Core Divisions</h2>
            <div className="djm-title-line"></div>
          </div>
          <div className="djm-divisions-grid">
            <div className="djm-division-card">
              <div className="djm-division-icon"></div>
              <h3>Medical Advisory & Applied Psychology</h3>
              <p>Medical interpretation, behavioral insight, and strategic health guidance</p>
            </div>
            <div className="djm-division-card">
              <div className="djm-division-icon"></div>
              <h3>Medico-Legal & Medical Ethics</h3>
              <p>Clinical-legal intelligence, litigation strategy, and risk advisory</p>
            </div>
            <div className="djm-division-card">
              <div className="djm-division-icon"></div>
              <h3>Biomedical Engineering & Sports Biomechanics</h3>
              <p>Scientific performance optimization and injury prevention</p>
            </div>
            <div className="djm-division-card">
              <div className="djm-division-icon"></div>
              <h3>AI Health Informatics & CSR Health Services</h3>
              <p>Strategic AI adoption and measurable health impact design</p>
            </div>
            <div className="djm-division-card">
              <div className="djm-division-icon"></div>
              <h3>Digital Health Accessories & Wellness Solutions</h3>
              <p>Innovative wellness and lifestyle products (Coming Soon)</p>
            </div>
          </div>
        </div>
      </section>

      {/* Global Positioning Statement */}
      <section className="djm-positioning-section">
        <div className="djm-container">
          <div className="djm-positioning-content">
            <div className="djm-positioning-quote">“</div>
            <p className="djm-positioning-text">
              Where Medicine, Law, Engineering, Psychology, Science, IT and Management converge into a single intelligence-driven healthcare ecosystem.
            </p>
            <p className="djm-positioning-author">— Dr. Eng. Jerish Neeraj</p>
          </div>
        </div>
      </section>

      {/* Our Team Section - 40 Professionals */}
      <section className="djm-team-section">
        <div className="djm-container">
          <div className="djm-section-header">
            <span className="djm-section-tag">Our Experts</span>
            <h2 className="djm-section-title">Meet Our 40+ Professional Team</h2>
            <div className="djm-title-line"></div>
            <p className="djm-section-subtitle">A multidisciplinary powerhouse of medical, legal, psychological, and scientific experts</p>
          </div>

          {/* Team Grid - 4 per row, 10 rows */}
          <div className="djm-team-grid">
{professionals.map((professional) => (
  <div key={professional.id} className="djm-team-card">

    <div className="djm-team-image">
      <img
        src={professional.image}
        alt={professional.name}
        onError={(e) => {
          e.target.src = '/profile.png';
        }}
      />
    </div>

    <h3 className="djm-team-name">{professional.name}</h3>

    <p className="djm-team-role">{professional.role}</p>

    {/* ✅ FIXED QUALIFICATION */}
 <div className="djm-team-qualification">
  {Array.isArray(professional.qualification)
    ? professional.qualification.map((item, index) => (
        <p key={index} className="djm-qualification-line">
          {item}
        </p>
      ))
    : professional.qualification
        ?.split(",")
        .map((item, index) => (
          <p key={index} className="djm-qualification-line">
            {item.trim()}
          </p>
        ))}
</div>

    <p className="djm-team-experience">
      {professional.experience}
    </p>

    <p className="djm-team-reg">
      {professional.regNo}
    </p>

    <div className="djm-team-hover">
      <span>Expert in {professional.role}</span>
    </div>

  </div>
))}
          </div>
        </div>
      </section>

      {/* Ethics & Governance Section */}
      <section className="djm-ethics-section">
        <div className="djm-container">
          <div className="djm-ethics-grid">
            <div className="djm-ethics-content">
              <div className="djm-section-tag">Ethics & Governance</div>
              <h2 className="djm-section-title">Our Operational Framework</h2>
              <div className="djm-title-line"></div>
              <ul className="djm-ethics-list">
                <li>✓ Evidence-based advisory only</li>
                <li>✓ No unnecessary clinical intervention</li>
                <li>✓ Confidential case handling</li>
                <li>✓ Ethical medico-legal reporting</li>
                <li>✓ Professional transparency</li>
                <li>✓ Strict regulatory compliance</li>
              </ul>
            </div>
            <div className="djm-ethics-quote">
              <p>Unlike traditional clinics, this platform operates as a unified multidisciplinary advisory intelligence system.</p>
            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default AboutUs;